module.exports = new __parcel__URL__("bike.f19e2940.svg").toString();